/**
 * API base URL for browser requests.
 * - Dev: localhost:5000
 * - Railway (same origin): /api
 * - Vercel (or other static host): REACT_APP_API_URL or Railway production API
 */
const DEFAULT_RAILWAY_API =
  process.env.REACT_APP_RAILWAY_API_URL ||
  'https://genuine-forgiveness-production-990e.up.railway.app/api';

export function getApiBase() {
  if (process.env.REACT_APP_API_URL) {
    return String(process.env.REACT_APP_API_URL).replace(/\/$/, '');
  }
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5000/api';
  }
  if (typeof window !== 'undefined') {
    const host = window.location.hostname || '';
    // Static host (Vercel preview/production) — API lives on Railway
    if (host.includes('vercel.app') || host.endsWith('.vercel.app')) {
      return DEFAULT_RAILWAY_API.replace(/\/$/, '');
    }
  }
  return '/api';
}
